module.exports = __webpack_public_path__ + "static/media/gifLightTheme.21b84dfb.svg";